import { createContext } from 'react';

const TableContext = createContext({
  dispatchRowChangedEvent: () => void 0,
  focusedRowIndexRef: { current: -1 },
  listenKeyEvents: false,
  setBodyNode: () => void 0
});

export { TableContext };
//# sourceMappingURL=TableContext.es.js.map
